module.exports = __webpack_public_path__ + "static/media/gota_modal.874503bc.svg";